module.exports = __webpack_public_path__ + "img/4.54566a5a.png";